import { useEffect, useState, useMemo } from 'react';

interface UseOrientationReturn {
    dimensions: {
        width: number;
        height: number;
    };
    isHorizontal: boolean;
}

export const useOrientation = (): UseOrientationReturn => {
    const [dimensions, setDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    const isHorizontal = useMemo(() => {
        return dimensions.width > dimensions.height;
    }, [dimensions.width, dimensions.height]);

    useEffect(() => {
        let timeoutId: NodeJS.Timeout;

        const handleResize = () => {
            clearTimeout(timeoutId);

            timeoutId = setTimeout(() => {
                const newWidth = window.innerWidth;
                const newHeight = window.innerHeight;

                setDimensions({
                    width: newWidth,
                    height: newHeight,
                });
            }, 100);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(timeoutId);
        };
    }, []);

    return {
        dimensions,
        isHorizontal,
    };
};
